import {useQuery} from 'react-query';
import {getTakenLoanDetails} from './getTakenLoanDetails';

const useGetTakenLoanDetails = (loanRequestGuid?: string) => {
  const {data, isLoading} = useQuery({
    queryKey: ['get-taken-loan-details', loanRequestGuid],
    queryFn: () => getTakenLoanDetails(loanRequestGuid),
    enabled: Boolean(loanRequestGuid),
  });

  return {data, isLoading};
};
export default useGetTakenLoanDetails;
